import {
    Component, Input, OnInit,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicecallService } from 'src/app/services';


export interface TripPoint {
    lat: number;
    lng: number;
    ts: number; // ms
    speed?: number;
    events?: { type: string; label?: string }[];
}

@Component({
    selector: 'app-predictions',
    templateUrl: './predictions.component.html',
    styleUrl: './predictions.component.css'
})
export class PredictionsComponent implements OnInit {
    predictionsUrl: SafeResourceUrl;
    pageType: string;
    entityId: string;
    constructor(private sanitizer: DomSanitizer, private sharedService: ServicecallService, private route: ActivatedRoute, private _router: Router) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.pageType = params['pageType'];
            this.entityId = params['entityId'];
            const dtc = params['dtc'];
            const vin = params['vin'];
            const edate = params['edate'];
            const risk = params['risk'];
            const prediction = params['prediction'];

            this.attachParamsToUrl(dtc, vin, edate, risk, prediction);
        });
    }

    private attachParamsToUrl(
        dtc: string,
        vin: string,
        edate: string,
        risk: string,
        prediction: string
    ): void {

        const baseUrl =
            this.sharedService.getConfiguration('analyticsUseCases')?.predictionsUrl ??
            'https://az0blob0idec0devqa.blob.core.windows.net/blob-file-idec-dev/Temp/Validops_phase2/U1_enterprise_dtc_dashboard%201.html?sp=r&st=2025-09-18T06:01:40Z&se=2025-10-31T14:16:40Z&spr=https&sv=2024-11-04&sr=b&sig=VfTaqPB%2Bw4IGMPdHmyg4kTPuJJvkqiUjNiX3mW5nuiU%3D';

        const extraParams = new URLSearchParams({
            dtc,
            vin,
            edate,
            risk,
            prediction
        }).toString();

        const finalUrl = `${baseUrl}&${extraParams}`;

        setTimeout(() => {
            this.predictionsUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
        }, 100);
    }

    /**
 * Handles back
 */
    handleBack() {
        if (this.pageType === 'vehicleProfilePrediction') {
            this._router.navigateByUrl(`/vehicles/profile/${this.entityId}`);
        } else if (this.pageType === 'casePrediction') {
            this._router?.navigateByUrl('/case/caseList');
        }
    }
}